<template>
<div class="chapter">
<div class="inner_page">
<div class="frame">
<img alt="85580.png" class="frame2" src="OEBPS/image/85580.png"/>
</div>
<div class="frame">
<img alt="100087.png" class="frame3" src="OEBPS/image/100087.png"/>
</div>
<div class="basic-text-frame">
<p class="bodytext2"><span class="byline">Bow Tie block</span></p>
</div>
<div class="basic-text-frame">
<p class="bodytext"><span class="testimonial-body"></span></p>
<p class="bodytext1"><span class="testimonial-body"></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// everlastingquilts_split2.vue?460e8779